import { applicationSlice, IApplicationState }                 from 'Redux/Slices/Application/ApplicationSlice';
import { userSlice, IUserState }                               from 'Redux/Slices/User/UserSlice';
import { organizerSlice, IOrganizerState }                     from 'Redux/Slices/Organizer/OrganizerSlice';
import { eventCategorySlice, IEventCategoryState }             from 'Redux/Slices/EventCategory/EventCategorySlice';
import { eventParentCategorySlice, IEventParentCategoryState } from 'Redux/Slices/EventParentCategory/EventParentCategorySlice';
import { eventSlice, IEventState }                             from 'Redux/Slices/Event/EventSlice';
import { authenticationSlice, IAuthenticationState }           from 'Redux/Slices/Authentication/AuthenticationSlice';
import { locationSlice, ILocationState }                       from 'Redux/Slices/Location/LocationSlice';
import { eventTicketSlice, IEventTicketState }                 from 'Redux/Slices/EventTicket/EventTicketSlice';
import { settingsSlice, ISettingsState }                       from 'Redux/Slices/Settings/SettingsSlice';
import { invoiceSlice, IInvoiceState }                         from 'Redux/Slices/Invoice/InvoiceSlice';
import { userTicketSlice, IUserTicketState }                   from 'Redux/Slices/UserTicket/UserTicketSlice';
import { salesSlice, ISalesState }                             from 'Redux/Slices/Sales/SalesSlice';
import { appUserSlice, IAppUserState }                         from 'Redux/Slices/AppUser/AppUserSlice';
import { organisationInvoiceSlice, IOrganisationInvoiceState } from 'Redux/Slices/OrganisationInvoice/OrganisationInvoiceSlice';
import { employeeSlice, IEmployeeState } from 'Redux/Slices/Employee/EmployeeSlice';
import { combineReducers, PayloadAction }                      from '@reduxjs/toolkit';


export type TRootState = {
  [applicationSlice.name]: IApplicationState;
  [authenticationSlice.name]: IAuthenticationState;
  [userSlice.name]: IUserState;
  [organizerSlice.name]: IOrganizerState;
  [eventCategorySlice.name]: IEventCategoryState;
  [eventSlice.name]: IEventState;
  [locationSlice.name]: ILocationState;
  [eventTicketSlice.name]: IEventTicketState;
  [settingsSlice.name]: ISettingsState;
  [invoiceSlice.name]: IInvoiceState;
  [userTicketSlice.name]: IUserTicketState;
  [salesSlice.name]: ISalesState;
  [eventParentCategorySlice.name]: IEventParentCategoryState;
  [appUserSlice.name]: IAppUserState;
  [organisationInvoiceSlice.name]: IOrganisationInvoiceState;
  [employeeSlice.name]: IEmployeeState;
}

export const rootState = {
  [applicationSlice.name]: applicationSlice.reducer,
  [authenticationSlice.name]: authenticationSlice.reducer,
  [userSlice.name]: userSlice.reducer,
  [organizerSlice.name]: organizerSlice.reducer,
  [eventCategorySlice.name]: eventCategorySlice.reducer,
  [eventSlice.name]: eventSlice.reducer,
  [locationSlice.name]: locationSlice.reducer,
  [eventTicketSlice.name]: eventTicketSlice.reducer,
  [settingsSlice.name]: settingsSlice.reducer,
  [invoiceSlice.name]: invoiceSlice.reducer,
  [userTicketSlice.name]: userTicketSlice.reducer,
  [salesSlice.name]: salesSlice.reducer,
  [eventParentCategorySlice.name]: eventParentCategorySlice.reducer,
  [appUserSlice.name]: appUserSlice.reducer,
  [organisationInvoiceSlice.name]: organisationInvoiceSlice.reducer,
  [employeeSlice.name]: employeeSlice.reducer,
};

export const rootReducer = (state: any, action: PayloadAction) => {
  if (action.type === 'user/logout') {
    state = undefined;
  }
  return combineReducers(rootState)(state, action);
};
